// extracted by mini-css-extract-plugin
module.exports = {"root":"BaseBtn_root__gg4_p","active":"BaseBtn_active__2PEOS"};